import axios from 'axios'
import { REACT_APP_API_ABM_FW } from '../../endpoints'

export async function getCarLots(queryString = ''){  
    let results = ''
    try {
        results = await axios.get(`${REACT_APP_API_ABM_FW}/abms/car_lot${queryString}`)
    } catch (error) {
        results = error.message
    }
    return results
}